module.exports = __webpack_public_path__ + "static/media/logo.72070269.gif";